import React, { useRef, useEffect } from 'react';

import { StyledTypography } from 'styles/common';

import { GOAL_PROGRESSES } from 'constants/ProjectConstants';

import { DateRange, ExpandedView } from './CohortSidePanel';
import { DropdownContainer, RangeSelector, SelectListComp } from './CommonComponents';

const MODULE_NAME = 'goal';

/**
 * @deprecated 25-06-2025
 */
function CohortCreationGoal({
  content,
  sectionLabel,
  sectionId,
  onHeaderClick,
  accessibleRole,
  isAllEmployeesSelected,
}) {
  const latestValue = useRef(isAllEmployeesSelected);

  useEffect(() => {
    latestValue.current = isAllEmployeesSelected;
  }, [isAllEmployeesSelected]);
  return (
    <>
      <ExpandedView
        content={content}
        sectionLabel={sectionLabel}
        sectionId={sectionId}
        headerComponent={() => (
          <DateRange
            sectionId={sectionId}
            onHeaderClick={onHeaderClick}
            isAllEmployeesSelected={isAllEmployeesSelected}
            accessibleRole={accessibleRole}
            goalTextLabel="Timeline"
            moduleName={MODULE_NAME}
          />
        )}
      />

      <DropdownContainer topGutter={3}>
        <RangeSelector
          sectionId={sectionId}
          dataKey="data"
          headingText=" Progress (Range)"
          minValue={-Infinity}
          maxValue={Infinity}
          isAllEmployeesSelected={isAllEmployeesSelected}
          accessibleRole={accessibleRole}
          moduleName={MODULE_NAME}
        />
      </DropdownContainer>
      <DropdownContainer topGutter={3}>
        <StyledTypography variant="body2" weight={600}>
          Status
        </StyledTypography>
        <SelectListComp
          dataKey="goalStatus"
          options={GOAL_PROGRESSES.map((goal) => ({ ...goal, key: goal.value }))}
          sectionId={sectionId}
          isMultiSelect
          isAllEmployeesSelected={isAllEmployeesSelected}
          accessibleRole={accessibleRole}
          moduleName={MODULE_NAME}
        />
      </DropdownContainer>
    </>
  );
}

export default CohortCreationGoal;
